import './ErrorFallback.css';
import { useTranslation } from '../i18n/LanguageContext.jsx';

function ErrorFallback({ error: _error, onReset }) {
  const { t } = useTranslation();

  return (
    <div className="error-fallback" role="alert">
      <div className="error-fallback__card">
        <h2 className="error-fallback__title">{t('error.title')}</h2>
        <p className="error-fallback__message">{t('error.message')}</p>
        <div className="error-fallback__actions">
          {/* "Try again" is a soft re-render (good for a transient error). For a
              deterministic crash the same error recurs and the boundary just
              re-shows this fallback, so offer a full reload too — it clears
              module/transient state and is a real escape hatch. */}
          <button className="error-fallback__retry" onClick={onReset} type="button">
            {t('error.retry')}
          </button>
          <button
            className="error-fallback__reload"
            onClick={() => window.location.reload()}
            type="button"
          >
            {t('error.reload')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorFallback;
